import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: (failureCount, err) => {
        // Don't retry 401s — the api layer handles re-prompting.
        const msg = err instanceof Error ? err.message : String(err)
        if (msg.includes('401')) return false
        return failureCount < 2
      },
    },
  },
})

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root element not found in index.html')

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
